import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('twofactor_authentication_setup'),
    subtitle: defineMessage('enter_the_code_from_the_authenticator_app'),
    description: defineMessage('enter_the_digit_code_ge_port_articlesupportlink'),
    wrongCodeErrorText: defineMessage('wrong_code'),
    authenticatorCodeLabel: defineMessage('authenticator_code'),
    authenticatorCodePlaceholder: defineMessage('enter_the_authenticator_code_1'),
    errorSetupVerificationCode: defineMessage('wrong_code'),
};
